import * as React from 'react';
import {
    Box, Button, TextField,
    Grid, Card, CardHeader,
    CardContent,
    SelectChangeEvent, FormControl, InputLabel, Select, MenuItem, IconButton, Stack, Typography,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Checkbox,
    ListItemText,
    FormHelperText
} from "@mui/material";
import BadgeIcon from '@mui/icons-material/Badge';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import { GoogleMap, useJsApiLoader, MarkerF, StandaloneSearchBox } from '@react-google-maps/api';
import { editVendor, saveVendor, deleteManufacturer } from '../../services/ManufacturerService';
import { useOidcAccessToken } from "@axa-fr/react-oidc";
import { useLocation, useNavigate } from 'react-router-dom';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import dayjs from 'dayjs';
import { getPreviousPageDetails } from '../../userSession/UserSession';
import CloseIcon from '@mui/icons-material/Close';
import { manualGeocode } from '../../utils/mapUtil';

const containerStyle = {
    width: '100%',
    height: '300px'
};

const libraries: any = ['places'];

const ManufacturerRegister: React.FC<any> = ({ open, onClose, rowData, afterSave }) => {
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyBHfzWHT7qgElExVxQzVRhCJtW1Z6YRILw",
        libraries: libraries
    });
    const [selectedVendorType, setSelectedVendorType] = React.useState<string | null>(null);
    const [subCategory, setSubCategory] = React.useState<string[]>([]);
    const [vendorData, setVendorData] = React.useState<any>({
        id: 0,
        name: "",
        displayName: "",
        status: "Active",
        primaryMobileNumber: '',
        email: "",
        website: "",
        accountNo: "",
        description: "",
        approvedBy: "",
        createdBy: '',
        checkName: '',
        zipCode: '',
        address: '',
        location: '',
        city: '',
        country: '',
        state: '',
        leadTime: '',
        createdAt: dayjs().toISOString(),
        updatedAt: '',
        routerNo: '',
        payTerms: '',
        vendorTypes: '',
        categories: [],
        services: [],
    });

    const [message, setMessage] = React.useState<any>({
        name: '',
        primaryMobileNumber: '',
        email: '',
        address: '',
        state: '',
        city: '',
        country: '',
        accountNo: null,
        area: '',
        services: '',
        tool: '',
        material: '',
        leadTime: '',
        vendorTypes: ''

    });
    const [map, setMap] = React.useState<google.maps.Map | null>(null);
    const inputRef = React.useRef<any>();
    const componentData = React.useRef<any>()
    const { accessToken, accessTokenPayload } = useOidcAccessToken();
    // Set createdBy from userId on mount
    React.useEffect(() => {
        async function setCreatedByFromUser() {
            if (accessToken && accessTokenPayload) {
                setVendorData(prev => ({ ...prev, createdBy: accessTokenPayload.oid }));
            }
        }
        setCreatedByFromUser();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accessToken, accessTokenPayload]);
    const [count, setCount] = React.useState(0);
    const navigate = useNavigate();
    let location = useLocation()
    const id = location.state?.vendorId;
    const [openToast, setOpenToast] = React.useState(false);
    const [vendorDataObject, setVendorDataObject] = React.useState<any>();
    const [unit, setUnit] = React.useState('');
    const [show, setShow] = React.useState(false);
    const [openDialogs, setOpenDialogs] = React.useState(false);
    const [createSuccess, setCreateSuccess] = React.useState(false);
    const [createError, setCreateError] = React.useState(false);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [updateSuccess, setUpdateSuccess] = React.useState(false);
    const [updateError, setUpdateError] = React.useState(false);
    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    const [success, setSuccess] = React.useState(false);
    const numberRegex = /^\d{10}$/;

    // Handle changes in the subcategory select box
    const handleSubCategoryChange = (event: SelectChangeEvent<string[]>) => {
        const selectedSubCategories = event.target.value as string[];
        setSubCategory(selectedSubCategories);

        // Update vendor data with selected subcategories
        setVendorData((prev) => ({
            ...prev,
            categories: selectedSubCategories,
            createdAt: dayjs().toISOString()

        }));
    };

    const handleClose = () => {
        onClose();
        setVendorData({
            name: "",
            status: "Active",
            primaryMobileNumber: '',
            email: "",
            website: "",
            accountNo: "",
            // services: "Service",
            description: "",
            approvedBy: "",
            createdBy: '',
            checkName: '',
            zipCode: '',
            address: '',
            location: '',
            city: '',
            country: '',
            state: '',
            leadTime: '',
            createdAt: dayjs().toISOString(),
            updatedAt: '',
            routerNo: '',
            payTerms: '',
            services: [],
            suppliers: [],
            vendorTypes: []
            // tools: [],
            // materials: []
        })
        setCount(0);
    };

    const onLoad = React.useCallback(function callback(map: any) {
        const bounds = new window.google.maps.LatLngBounds(componentData.current);
        map.fitBounds(bounds);
        setMap(map)
    }, [])

    const onUnmount = React.useCallback(function callback(map: any) {
        setMap(null)
    }, [])

    const getLocation = () => {

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                componentData.current = { lat: position.coords.latitude, lng: position.coords.longitude };
            });
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
    }

    const onClick = (e: google.maps.MapMouseEvent) => {
        componentData.current = { lat: e.latLng?.lat(), lng: e.latLng?.lng() }
        let locationObject: any = {}
        const geocoder = new google.maps.Geocoder();
        const fulladdress: any[] = [];
        geocoder
            .geocode({ location: componentData.current })
            .then((response) => {
                if (response.results[0]) {
                    // eslint-disable-next-line array-callback-return
                    response.results[0].address_components.forEach((address: any) => {
                        if (address.types.includes("street_number") || address.types.includes("sublocality_level_1") || address.types.includes("sublocality_level_2") || address.types.includes("route") || address.types.includes("landmark") || address.types.includes("premise") || address.types.includes("plus_code")) {
                            fulladdress.push(address.long_name);
                            locationObject['address'] = fulladdress.join(" ");
                        }
                        else if (address.types.includes("locality")) {
                            locationObject['city'] = address.long_name;
                        }
                        else if (address.types.includes("administrative_area_level_1")) {
                            locationObject['state'] = address.long_name
                        }
                        else if (address.types.includes("country")) {
                            locationObject['country'] = address.long_name
                        }
                        else if (address.types.includes("postal_code")) {
                            locationObject['zipCode'] = address.long_name
                        }
                    })
                }
                setVendorData({
                    ...vendorData, zipCode: locationObject.zipCode, country: locationObject.country,
                    address: locationObject.address, city: locationObject.city, state: locationObject.state,
                    location: Object.values(componentData.current).join(",")
                });
            })
    }

    const handlePlaceChanged = () => {
        const places = inputRef.current?.getPlaces();
        if (!places || places.length === 0) return;

        const place = places[0];
        const fullAddress: string[] = [];
        const locationObject: any = {};

        if (place && place.address_components) {
            place.address_components.map((address: any) => {
                if (
                    address.types.includes("street_number") ||
                    address.types.includes("sublocality_level_1") ||
                    address.types.includes("sublocality_level_2") ||
                    address.types.includes("route") ||
                    address.types.includes("landmark") ||
                    address.types.includes("premise")
                ) {
                    fullAddress.push(address.long_name);
                    locationObject["address"] = fullAddress.join(" ");
                } else if (address.types.includes("locality")) {
                    locationObject["city"] = address.long_name;
                } else if (address.types.includes("administrative_area_level_1")) {
                    locationObject["state"] = address.long_name;
                } else if (address.types.includes("country")) {
                    locationObject["country"] = address.long_name;
                } else if (address.types.includes("postal_code")) {
                    locationObject["zipCode"] = address.long_name;
                } else {
                    locationObject["zipCode"] = "";
                    locationObject["address"] = fullAddress.join(" ");
                }
            });
            componentData.current = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
            setVendorData({
                ...vendorData,
                address: locationObject.address || '',
                city: locationObject.city || '',
                state: locationObject.state || '',
                country: locationObject.country || '',
                zipCode: locationObject.zipCode || '',
                location: `${place.geometry.location.lat()}, ${place.geometry.location.lng()}`,
            });
        }
    };

    const inputchange = (e: any) => {
        const { name, value } = e.target;
        if (name === 'primaryMobileNumber') {
            const numericValue = value.replace(/\D/g, '').slice(0, 10);
            setVendorData(prev => ({
                ...prev,
                [name]: numericValue
            }));
        } else {
            setVendorData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const validation = () => {
        let validated: any = true;
        if (vendorData.name === '') {
            message.name = 'Enter Name';
            validated = false;
        }

        if (vendorData.primaryMobileNumber && vendorData.primaryMobileNumber.length > 0) {
            if (!numberRegex.test(vendorData.primaryMobileNumber)) {
                message.primaryMobileNumber = 'Enter Your Mobile Number with exactly 10 digits';
                validated = false;
            }
        }

        if (vendorData.email && vendorData.email.length > 0) {
            if (regex.test(vendorData.email) === false) {
                message.email = 'Enter a valid Email';
                validated = false;
            }
        }

        return validated;
    }

    // Sample API call to check if manufacturer is associated with any materials
    const checkManufacturerMaterials = async (manufacturerId: number) => {
        // Replace with your actual API endpoint and logic
        // Example:
        // const response = await fetch(`/api/manufacturers/${manufacturerId}/materials`);
        // const data = await response.json();
        // return data.isAssociated;
        return false; // Default for now
    };

    // Delete manufacturer with warning if associated
    const handleDeleteManufacturer = async (manufacturerId: number) => {
        const isAssociated = await checkManufacturerMaterials(manufacturerId);
        if (isAssociated) {
            window.alert('Warning: This manufacturer may be associated with materials. Please confirm deletion only if not associated with any materials.');
            return;
        }
        // Proceed with actual delete logic
        try {
            const result = await deleteManufacturer(manufacturerId, accessToken);
            if (result.status === 200 || result.status === 204) {
                window.alert('Manufacturer deleted successfully.');
                // Optionally refresh list or close dialog
            } else {
                window.alert('Failed to delete manufacturer.');
            }
        } catch (error) {
            window.alert('Error occurred while deleting manufacturer.');
        }
    };

    const handleSubmit = async () => {
        console.log("called")
        setCount(count + 1);
        let validated = validation();
        if (validated === true) {
            setOpenDialogs(true);
            console.log("validated")
            // Debug: log vendorData.createdBy before mapping
            console.log('vendorData.createdBy before mapping:', vendorData.createdBy);
            // Map frontend fields to backend expected fields
            const mappedPayload = {
                ...vendorData,
                phone: vendorData.primaryMobileNumber,
                zipcode: vendorData.zipCode,
                createdBy: vendorData.createdBy
            };
            console.log('createdBy before submit:', mappedPayload.createdBy);
            let result = await saveVendor(mappedPayload, accessToken)
            console.log(result)
            console.log(mappedPayload)
            setOpenDialogs(true);
            if (result.status === 201 && result.ok === true) {
                setCreateSuccess(true);
                if (afterSave) afterSave();
                setTimeout(() => {
                    onClose && onClose();
                    handleClose();
                }, 2000);
            }
            else {
                setCreateError(true);
            }
        }
        else {
            setCreateError(true);
        }
    }

    const handleCancel = () => {
        const previousPageDetails = getPreviousPageDetails();
        if (previousPageDetails && previousPageDetails.path) {
            navigate(previousPageDetails.path,
                { state: { selectedTab: previousPageDetails.tabPosition } }
            );
        } else {
            // fallback: just close dialog
            onClose && onClose();
        }
    }

    const convertLocation = (locationString: any) => {
        if (!locationString) {
            return { lat: 0, lng: 0 };
        }

        let locationObject: any = {}
        let string = locationString;
        let st = string.split(",");
        locationObject['lat'] = Number(st[0]);
        locationObject['lng'] = Number(st[1]);
        return locationObject;
    }

    const updateHandleSubmit = async () => {
        setCount(count + 1);
        let validated = validation();
        if (vendorDataObject.name === vendorData.name && vendorDataObject.displayName === vendorData.displayName
            && vendorDataObject.email === vendorData.email
            && vendorDataObject.primaryMobileNumber === vendorData.primaryMobileNumber &&
            vendorDataObject.website === vendorData.website && vendorDataObject.checkName === vendorData.checkName
            && vendorDataObject.services === vendorData.services && vendorDataObject.address === vendorData.address &&
            vendorDataObject.state === vendorData.state && vendorDataObject.city === vendorData.city &&
            vendorDataObject.country === vendorData.country && vendorDataObject.zipCode === vendorData.zipCode &&
            vendorDataObject.description === vendorData.description && vendorDataObject.vendorTypes === vendorData.vendorType && vendorDataObject.categories.toString() === vendorData.categories.toString()) {
            setOpenToast(true);
            setSuccess(true);
        }
        else {
            if (validated === true) {
                setOpenDialog(true);
                console.log("call api")
                // Map phone, zipcode, and createdBy for backend
                const mappedPayload = {
                    ...vendorData,
                    phone: vendorData.primaryMobileNumber,
                    zipcode: vendorData.zipCode,
                    createdBy: vendorData.createdBy || accessTokenPayload?.oid
                };
                let result = await editVendor(mappedPayload, accessToken);
                console.log(result)
                if (result.status === 200 || result.status === 201) {
                    setUpdateSuccess(true);
                    if (afterSave) afterSave();
                    setTimeout(() => {
                        onClose && onClose();
                        handleClose();
                    }, 2000);
                }
                else {
                    setUpdateError(true)
                }
            }
        }
    };

    React.useEffect(() => {
        getLocation();
        if (rowData !== undefined) {
            setVendorDataObject(rowData);
            setSelectedVendorType(rowData?.vendorTypes);
            setSubCategory(rowData?.categories);
            if (rowData.location) {
                componentData.current = convertLocation(rowData.location);
            }
            // Map backend fields to frontend state if necessary
            setVendorData({
                ...rowData,
                primaryMobileNumber: rowData.primaryMobileNumber || rowData.phone || '',
                zipCode: rowData.zipCode || rowData.zipcode || ''
            });
            setShow(true);
        }
    }, [rowData]);

    const handleAlertClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        setSuccess(false);
    };

    const handleManualGeocode = async () => {
        try {
            const result = await manualGeocode(vendorData);
            setVendorData(prev => ({
                ...prev,
                location: result.location
            }));

            if (map) {
                map.panTo(result.geometry);
                map.setZoom(20);
            }
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <>
            <Dialog
                aria-labelledby="customized-dialog-title"
                open={open}
                fullWidth={true}
                maxWidth={'md'}
            >
                <DialogTitle sx={{ fontSize: "16px" }}>
                    Manufacturer Registration
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <Grid container justifyContent="center" alignItems="center" rowSpacing={2} columnSpacing={{ xs: 4, sm: 2, md: 2 }}>
                        <Grid item xs={12} md={12} sm={12}>
                            <CardContent sx={{
                                display: 'block',
                                alignItems: 'center',
                                '& > :not(style)': { m: 2 },
                            }}>
                                <Card className='vendorcard'>
                                    <CardHeader
                                        title={
                                            <div className='VendorTitle'><BadgeIcon />&nbsp;Name and Contact
                                            </div>
                                        }
                                    />
                                    <Grid container spacing={2} pb={3} pr={3} pl={3} pt={0}>
                                        <Grid item xs={6}>
                                            <TextField
                                                id="vendor-registration-input-name"
                                                label="Name"
                                                size="small"
                                                name="name"
                                                fullWidth
                                                value={vendorData?.name}
                                                error={(vendorData.name === '' && count !== 0)}
                                                helperText={(vendorData.name === '' && count !== 0) ? message.name : null}
                                                onChange={(e) => inputchange(e)}
                                                required
                                                disabled={rowData !== undefined}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                error={(count !== 0 && vendorData.email !== '' && regex.test(vendorData.email) === false)}
                                                id="vendor-registration-input-email"
                                                label="Primary Email"
                                                size="small"
                                                fullWidth
                                                name="email"
                                                helperText={(count !== 0 && vendorData.email !== '' && regex.test(vendorData.email) === false) ? message.email : null}
                                                value={vendorData?.email}
                                                onChange={(e) => inputchange(e)}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                error={(count !== 0 && vendorData.primaryMobileNumber !== '' && !numberRegex.test(vendorData.primaryMobileNumber))}
                                                id="vendor-registration-input-mobile-number"
                                                label="Primary Mobile Number"
                                                size="small"
                                                fullWidth
                                                name="primaryMobileNumber"
                                                value={vendorData?.primaryMobileNumber || ''}
                                                helperText={(count !== 0 && vendorData.primaryMobileNumber !== '' && !numberRegex.test(vendorData.primaryMobileNumber)) ? message.primaryMobileNumber : null}
                                                onChange={inputchange}
                                                InputProps={{
                                                    inputProps: {
                                                        type: 'text',
                                                    },
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                id="vendor-registration-input-website"
                                                label="Website"
                                                size="small"
                                                fullWidth
                                                name="website"
                                                value={vendorData?.website}
                                                onChange={(e) => inputchange(e)}
                                            />
                                        </Grid>
                                        {/* Subcategory Select Box */}
                                        <Grid item xs={6}>
                                            {selectedVendorType && (
                                                <FormControl fullWidth size="small">
                                                    <InputLabel id="sub-category-label">Category</InputLabel>
                                                    <Select
                                                        labelId="sub-category-label"
                                                        id="vendor-registration-select-sub-category"
                                                        multiple
                                                        value={subCategory || rowData?.categories}
                                                        onChange={handleSubCategoryChange}
                                                        label="Category"
                                                        renderValue={(selected) => selected.join(', ')}
                                                    >
                                                    </Select>
                                                </FormControl>
                                            )}
                                        </Grid>
                                    </Grid>
                                </Card>
                                <Card className='vendorcard'>
                                    <CardHeader className='VendorTitle'
                                        title={
                                            <div className='VendorTitle'><LocationOnIcon />&nbsp;Address
                                            </div>
                                        }
                                    />
                                    <Grid container spacing={2} pb={3} pr={3} pl={3} pt={0}>
                                        <Grid item xs={6}>
                                            {isLoaded
                                                &&
                                                (<StandaloneSearchBox
                                                    onLoad={ref => inputRef.current = ref}
                                                    onPlacesChanged={handlePlaceChanged}
                                                >
                                                    <TextField
                                                        className='textfield'
                                                        id="vendor-registration-input-street-address"
                                                        label="Street Address"
                                                        size="small"
                                                        name="address"
                                                        value={vendorData?.address}
                                                        onChange={(e) => inputchange(e)}
                                                        fullWidth
                                                        onBlur={handleManualGeocode}
                                                    />
                                                </StandaloneSearchBox>)}
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                id="vendor-registration-input-city"
                                                label="City"
                                                size="small"
                                                fullWidth
                                                name="city"
                                                value={vendorData?.city}
                                                onChange={(e) => inputchange(e)}
                                                onBlur={handleManualGeocode}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                id="vendor-registration-input-state"
                                                label="State"
                                                type="text"
                                                size="small"
                                                name="state"
                                                value={vendorData?.state}
                                                onChange={(e) => inputchange(e)}
                                                fullWidth
                                                onBlur={handleManualGeocode}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                id="vendor-registration-input-country"
                                                label="Country"
                                                size="small"
                                                name="country"
                                                value={vendorData?.country}
                                                onChange={(e) => inputchange(e)}
                                                fullWidth
                                                onBlur={handleManualGeocode}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                id="vendor-registration-input-zip-code"
                                                label="Zip Code"
                                                size="small"
                                                name="zipCode"
                                                value={vendorData?.zipCode}
                                                onChange={(e) => inputchange(e)}
                                                fullWidth
                                                onBlur={handleManualGeocode}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Grid item xs={13} pt={1}>
                                                {isLoaded ? (
                                                    <GoogleMap
                                                        mapContainerStyle={containerStyle}
                                                        center={componentData?.current}
                                                        zoom={10}
                                                        onLoad={onLoad}
                                                        onUnmount={onUnmount}
                                                        onClick={onClick}
                                                    >
                                                        <MarkerF
                                                            position={componentData.current}
                                                        >
                                                        </MarkerF>
                                                        <></>
                                                    </GoogleMap>
                                                ) : <></>}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Card>
                                <Card className='vendorcard'>
                                    <CardHeader className='VendorTitle'
                                        title={
                                            <div className='VendorTitle'><NoteAltIcon />&nbsp;Description
                                            </div>
                                        }
                                    />
                                    <Grid item xs={12} pb={3} pr={3} pl={3} pt={0}>
                                        <TextField
                                            className='textfield'
                                            id="vendor-registration-input-descriptions"
                                            label="Descriptions"
                                            multiline
                                            minRows={3}
                                            name="description"
                                            value={vendorData?.description}
                                            onChange={(e) => inputchange(e)}
                                            fullWidth
                                        />
                                    </Grid>
                                </Card>
                            </CardContent>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'end' }}>
                        <Stack spacing={2} direction="row">
                            {rowData ? (
                                <Button id="vendor-registration-button-update" variant="contained" className='sucessButton' size="medium" onClick={updateHandleSubmit}>
                                    Update
                                </Button>
                            ) : (
                                <Button id="vendor-registration-button-save" className='sucessButton' variant="contained" size="medium" onClick={handleSubmit}>
                                    Save
                                </Button>
                            )}
                            <Button id="vendor-registration-button-cancel" className='primaryTonalButton' variant="contained" size="medium" onClick={handleClose}>Cancel</Button>
                        </Stack>
                    </Box>
                </DialogActions>
            </Dialog>
            {/* <CustomDialog
                open={openDialogs}
                onClose={() => setCancels()}
                reload={() => null}
                conflictWarning={false}
                success={createSuccess}
                error={createError}
                errorCode={errorCode}
                debugMessage={errorMessage}
                timestamp={timestamp}
                detailedMessage={errorReason}
                Content={createSuccess ? "Created Successfully" : " Error Couldnot Created "} />
            <CustomDialog
                open={openDialog}
                onClose={() => setCancel()}
                reload={() => null}
                conflictWarning={false}
                success={updateSuccess}
                error={updateError}
                errorCode={errorCode}
                debugMessage={errorMessage}
                timestamp={timestamp}
                detailedMessage={errorReason}
                Content={updateSuccess ? "Updated Successfully" : "Not Updated Successfully  "}
            /> */}
            <Dialog open={success} >
                <DialogTitle className='success' sx={{ backgroundColor: "rgb(255,193,0) !important" }}>
                    <Box paddingLeft={8} paddingRight={8}>
                        <Typography textAlign={'center'}>
                            <InfoOutlinedIcon sx={{ fontSize: "50px", color: "white" }} /></Typography>
                    </Box>
                </DialogTitle>
                <Box paddingLeft={8} paddingRight={8}>
                    <DialogContent >
                        <DialogContentText textAlign={'center'} fontSize={'18px'} fontWeight={'500'}>No value has been changed.</DialogContentText>
                    </DialogContent>
                    <DialogActions style={{ justifyContent: "center" }}>
                        <Button variant='contained' className="NoChangeButton" onClick={handleAlertClose}>Ok</Button>
                    </DialogActions>
                </Box>
            </Dialog>
        </>
    )
};

export default ManufacturerRegister;